import { render, staticRenderFns } from "./DiscoveryPageSingle.vue?vue&type=template&id=0ea9cbac&scoped=true&"
import script from "./DiscoveryPageSingle.vue?vue&type=script&lang=js&"
export * from "./DiscoveryPageSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9cbac",
  null
  
)

export default component.exports